import { useState, useCallback } from "react";
import { bulkUploadQuiz } from "../../service/UserService/QuizAttemptService";



export const useBulkUploadQuiz = (quizId) => {
  const [bulkData, setBulkData] = useState(null);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [bulkError, setBulkError] = useState(null);

  const addBulkQuizQuestions = useCallback(
    async (payload) => {
      setBulkLoading(true);
      setBulkError(null);

      try {
        const response = await bulkUploadQuiz(quizId, payload);

        setBulkData(response);

        if (response?.status === "ERROR") {
          setBulkError(response?.message || "Validation failed");
        }

        return response;
      } catch (error) {
        const fallbackMessage = error?.message || "An unexpected error occurred during upload";
        setBulkError(fallbackMessage);
        throw error;
      } finally {
        setBulkLoading(false);
      }
    },
    [quizId]
  );

  const resetBulkState = useCallback(() => {
    setBulkData(null);
    setBulkLoading(false);
    setBulkError(null);
  }, []);

  return {
    bulkData,
    bulkLoading,
    bulkError,
    addBulkQuizQuestions,
    resetBulkState,
  };
};